import { Injectable } from '@angular/core';
import { Mixpanel } from 'mixpanel-browser';

@Injectable()
export class MixpanelService {
  constructor(readonly instance: Mixpanel) {}
}
